import 'babel-polyfill' // for IE
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from '@/store/store'
import './assets/styles/app.scss'
import '../.devtools'
import './directives'
import PortalContextRequiredTemplate from '@templates/PortalContextRequiredTemplate'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VTooltip from 'v-tooltip'
import VueCompositionAPI from '@vue/composition-api'
/**
 * BEGIN Font Awesome Configuration
 *
 * todo: let's move this into its own file and see if we can come up with a dry way to configure the SVGs we are using
 */
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faSpinner,
  faCaretDown,
  faCaretUp,
  faSearch,
  faColumns,
  faCheck,
  faCheckCircle,
  faQuestionCircle,
  faTimesCircle,
  faCog,
  faSortUp,
  faSortDown,
  faChevronLeft,
  faEllipsisV,
  faChevronRight,
  faPlus,
  faMinus,
  faEdit,
  faLock,
  faExclamationTriangle,
  faTimes,
  faChevronDown,
  faChevronUp,
  faGripVertical,
  faExternalLinkAlt,
  faMinusCircle,
  faFileArchive

} from '@fortawesome/free-solid-svg-icons'

import {
  faSquare,
  faCheckSquare,
  faWindowClose,
  faCalendarAlt
} from '@fortawesome/free-regular-svg-icons'
import VueCountryCode from "vue-country-code";

import isInternalUser from '@mixins/isInternalUser'
import isSsoUser from '@mixins/isSsoUser'
import hiddenRouteParams from '@mixins/hiddenRouteParams'

import CloudCannonContent from '@organisms/CloudCannonContent'
Vue.component('portal-context-required-template', PortalContextRequiredTemplate)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(VTooltip)
Vue.use(VueCompositionAPI);
Vue.use(VueCountryCode);

library.add(
  faExclamationTriangle,
  faLock,
  faEdit,
  faQuestionCircle,
  faCheckCircle,
  faTimesCircle,
  faSpinner,
  faEllipsisV,
  faCaretDown,
  faCaretUp,
  faSearch,
  faColumns,
  faSquare,
  faCheck,
  faCheckSquare,
  faCog,
  faSortUp,
  faSortDown,
  faChevronLeft,
  faChevronRight,
  faWindowClose,
  faPlus,
  faMinus,
  faWindowClose,
  faCalendarAlt,
  faTimes,
  faChevronDown,
  faChevronUp,
  faGripVertical,
  faExternalLinkAlt,
  faMinusCircle,
  faFileArchive
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.mixin(isInternalUser)
Vue.mixin(isSsoUser)
Vue.mixin(hiddenRouteParams)

dom.watch() // This will kick of the initial replacement of i to svg tags and configure a MutationObserver

/**
 * END Font Awesome Configuration
 */
export const eventBus = new Vue()
eventBus.$on('sendUserToRoute', (routeName) => {
  router.push({ name: routeName }).catch((e) => {
    if(e.name !== 'NavigationDuplicated') {
      throw e;
    }
  });
})

Vue.config.productionTip = false
Vue.component('cloud-cannon-content', CloudCannonContent)

/* router.afterEach((to, from) => {
  if (from.name == "group-benefits") {
    //window.location.reload(true);
    //router.push(to);
  }
}) */

router.beforeEach(async(to, from, next) => { //'from' unused parameter needs to be passed for vue router to work
  await store.restored
  // This is a workaround to identify if the page was refreshed. For some reason , windows.performance and identify refresh
  // with session storage are not working with vue-router
  const isInitialNavigationOrRefresh = from.path === '/' && Object.keys(from.params).length === 0
  const storedHiddenRouteParams = store.getters['hiddenRouteData/getHiddenRouteData']
  store.commit('hiddenRouteData/UPDATE_HIDDEN_ROUTE_PARAMS_STATE',
    isInitialNavigationOrRefresh ? storedHiddenRouteParams : to.params
  )

  const loggedIn = store.getters['loggedIn']
  if (!loggedIn && !to.meta.isPublic ) {
    try {
      await router.push({ name: 'login' })
    } catch (err) {
      if (err.name !== 'NavigationDuplicated') {
        throw err
      }
    }
  } else if (to.meta.emailRoute && loggedIn) {
    store.dispatch('cacheBuster/NUKE_STATE')
    next()
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
